import { createAction, props } from "@ngrx/store";
import { ISimulationData } from "../states/simulation.state";

export const LoadSimulationSuccess = createAction(
  "[Simulation Data] Load Simulation Data Success",
  props<{ simulationData: ISimulationData }>()
);
